<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

const option = {
  title: [
    {
      text: "20.8%",
      x: "center",
      top: "35%",
      textStyle: {
        color: "#FFFFFF",
        fontSize: 36,
        fontWeight: "100",
      },
    },
    {
      text: "一",
      x: "center",
      y: "25%",
      textStyle: {
        fontSize: "50",
        color: "#FFFFFF",
        fontFamily: "DINAlternate-Bold, DINAlternate",
        foontWeight: "600",
      },
    },
  ],
  legend: {
    align: "center",
    top: "70%",
    type: "plain",
    textStyle: {
      color: "#fff",
      fontSize: 40,
    },
    icon: "none",
    itemGap: 35,
    itemWidth: 25,
  },
  // backgroundColor: "#111",
  polar: {
    radius: ["42%", "65%"],
    center: ["50%", "35%"],
  },
  angleAxis: {
    max: 100,
    show: false,
  },
  radiusAxis: {
    type: "category",
    show: true,
    axisLabel: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  series: [
    {
      name: "看平",
      type: "bar",
      roundCap: true,
      barWidth: 40,
      showBackground: true,
      backgroundStyle: {
        color: "#03AFEE",
      },
      data: [20.8],
      coordinateSystem: "polar",
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 0,
              color: "#A3D8FF",
            },
            {
              offset: 1,
              color: "#FF7723",
            },
          ]),
        },
      },
    },
    {
      name: "",
      type: "pie",
      startAngle: 80,
      radius: ["74%"],
      hoverAnimation: false,
      center: ["50%", "35%"],
      itemStyle: {
        color: "rgba(66, 66, 66, .1)",
        borderWidth: 0,
        borderColor: "#02BDEE",
      },
      data: [100],
    },
    {
      name: "",
      type: "pie",
      startAngle: 80,
      radius: ["38%"],
      hoverAnimation: false,
      center: ["50%", "50%"],
      itemStyle: {
        color: "rgba(66, 66, 66, 0)",
        borderWidth: 0,
        borderColor: "#5269EE",
      },
      data: [100],
    },
  ],
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);

    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
